export function participantRowContractorId(row) {
  if (row.dataset.newPersonRow !== undefined) return "" // not a Contractor until the form saves

  const contractorIdInput = row.querySelector('input[name*="[contractor_id]"]')
  if (contractorIdInput?.value) return String(contractorIdInput.value)

  const checkbox = row.querySelector("input[type='checkbox']")
  return checkbox ? String(checkbox.value) : ""
}

export function reorderParticipantRows(panel, memberIds) {
  const rows = Array.from(panel.querySelectorAll("[data-participant-row]"))
  if (rows.length === 0) return

  const container = rows[0].parentElement
  rows
    .sort((left, right) => {
      const leftId = participantRowContractorId(left)
      const rightId = participantRowContractorId(right)
      const leftRank = memberIds.has(leftId) ? 0 : 1
      const rightRank = memberIds.has(rightId) ? 0 : 1
      if (leftRank !== rightRank) return leftRank - rightRank

      const leftName = left.querySelector("label")?.textContent?.trim() || ""
      const rightName = right.querySelector("label")?.textContent?.trim() || ""
      return leftName.localeCompare(rightName, undefined, { sensitivity: "base" })
    })
    .forEach((row) => container.appendChild(row))
}

export function checkedParticipantLaborUnitsInputs(panel) {
  return Array.from(panel.querySelectorAll("[data-participant-row]"))
    .filter((row) => row.querySelector("input[type='checkbox']")?.checked)
    .map((row) => row.querySelector("[data-participant-labor-units-input]"))
    .filter(Boolean)
}

export function applyParticipantLaborUnits(panel) {
  const value = panel.querySelector("[data-participant-mass-labor-units-input]")?.value
  if (!value) return

  checkedParticipantLaborUnitsInputs(panel).forEach((input) => {
    input.value = value
  })
}

export function namedParticipantIdsFromRows(rows) {
  return new Set(
    rows
      .filter((row) => row.querySelector("input[type='checkbox']")?.checked)
      .map((row) => participantRowContractorId(row))
      .filter(Boolean)
  )
}

export function syncSupplyExitContractorSelects(selects, namedIds) {
  selects.forEach((select) => {
    Array.from(select.options).forEach((option) => {
      if (option.value === "") return
      option.hidden = !namedIds.has(option.value)
    })

    if (namedIds.size === 1 && !namedIds.has(select.value)) {
      select.value = namedIds.values().next().value
    } else if (namedIds.size === 0) {
      select.value = ""
    } else if (select.value && !namedIds.has(select.value)) {
      select.value = ""
    }
  })
}
